import gql from "graphql-tag";

const CREATE_MANUFACTURER_OFFER = gql`
  mutation createManufacturerOffer($projectId: ID!) {
    createManufacturerOffer(projectId: $projectId)
  }
`;

export default CREATE_MANUFACTURER_OFFER;
